const SALES_SETTINGS_ROUTE_PREFIXES = [
    '/SalesInvoice',
    '/DirectInvoice',
    '/SalesPostingReport',
];

const WORK_SCHEDULE_SETTINGS_ROUTE_PREFIXES = [
    '/WorkSchedule',
    '/JobCompletion',
    '/JobCompletionReport',
];

const DASHBOARD_SETTINGS_ROUTE_PREFIXES = [
    '/Home',
];

function matchesRoutePrefix(pathname, prefixes) {
    return prefixes.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    );
}

export function isSalesSettingsRoute(pathname = '') {
    return matchesRoutePrefix(pathname, SALES_SETTINGS_ROUTE_PREFIXES);
}

export function isWorkScheduleSettingsRoute(pathname = '') {
    return matchesRoutePrefix(pathname, WORK_SCHEDULE_SETTINGS_ROUTE_PREFIXES);
}

export function isDashboardSettingsRoute(pathname = '') {
    return matchesRoutePrefix(pathname, DASHBOARD_SETTINGS_ROUTE_PREFIXES);
}

export function hasContextualSettings(pathname = '') {
    return isSalesSettingsRoute(pathname)
        || isWorkScheduleSettingsRoute(pathname)
        || isDashboardSettingsRoute(pathname);
}
